<template>
  <v-container fluid>
    <h2>Welkom bij</h2>
    <h1 class="authentication__title">Boodschapp</h1>

    <v-layout row>
      <v-flex xs12>
        <router-link to="login">
          <v-btn color="blue">Inloggen</v-btn>
        </router-link>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <router-link to="register">
          <v-btn color="blue">Registreren</v-btn>
        </router-link>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Button from '../../atoms/Button'
export default {
  name: '',
  data () {
    return {
    }
  },
  components: {
    appButton: Button
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.authentication {

}
</style>



// WEBPACK FOOTER //
// Welcome.vue?0761b131